import { useState } from "react";
import "./App.css";
import PlayerForm from "./components/PlayerForm";
import ScoreGrid from "./components/ScoreGrid";

function App() {
  const [players, setPlayers] = useState<string[]>([]);
  const [gameStarted, setGameStarted] = useState(false);

  const handlePlayerSubmit = (playerNames: string[]) => {
    setPlayers(playerNames);
    setGameStarted(true);
  };

  const resetGame = () => {
    setPlayers([]);
    setGameStarted(false);
  };

  const appClassName = gameStarted
    ? "App game-started"
    : "App game-not-started";

  return (
    <div className={appClassName}>
      <header className="App-header">
        <img
          src="/game_logo.png"
          alt="Great Western Trail Logo"
          className="game-logo"
        />
      </header>
      <main>
        {!gameStarted ? (
          <PlayerForm onSubmit={handlePlayerSubmit} />
        ) : (
          <ScoreGrid players={players} onReset={resetGame} />
        )}
      </main>
    </div>
  );
}

export default App;
